export default "__VITE_ASSET__D5M$MyDk__"